import { call, put, takeEvery } from '@redux-saga/core/effects';
import { SAVE_NEW_ESROG } from '../actions/actionsTypes';
import { postDataWithHeaders } from '../httpClient';
import { SaveEsrogActionType } from '../actions/saveEsrogAction';
import { resetUser } from '../slices/userSlice/userSlice';

export function* saveEsrog(action: SaveEsrogActionType): any {
  try {
    yield call(postDataWithHeaders, '/api/v1/admin/esrogs', action.headers, {
      kind: action.kind,
      pitum: action.pitum,
      active: true,
    });
    if (action.onSuccess) {
      action.onSuccess();
    }
  } catch (e: any) {
    if (e?.status === 401) {
      yield put(resetUser());
      alert('Sorry, Login Expired! Please Login again');
    } else {
      alert('Failed to save Esrog');
    }
  }
}

export function* watchSaveEsrog() {
  yield takeEvery(SAVE_NEW_ESROG, saveEsrog);
}
